import { render, staticRenderFns } from "./BigScreenEcharts.vue?vue&type=template&id=d4aff934&"
import script from "./BigScreenEcharts.vue?vue&type=script&lang=js&"
export * from "./BigScreenEcharts.vue?vue&type=script&lang=js&"
import style0 from "./BigScreenEcharts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports